<!--<template>-->
<!--  <b-card-->
<!--    no-shadow-->
<!--    class="div-with-loading b-con-loading__container"-->
<!--  >-->
<!--    <b-alert-->
<!--      icon="icon-check-circle"-->
<!--      icon-pack="feather"-->
<!--      class="mb-5"-->
<!--      color="success"-->
<!--      :active="activeAlert"-->
<!--    >-->
<!--      Cambios Guardados correctamente-->
<!--    </b-alert>-->
<!--    &lt;!&ndash; Img Row &ndash;&gt;-->
<!--    <div class="text-center items-center mb-base">-->
<!--      &lt;!&ndash;b-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" /&ndash;&gt;-->
<!--      <b-avatar-->
<!--        :src="usuario.avatar"-->
<!--        size="70px"-->
<!--        class="mr-4 mb-2"-->
<!--      />-->
<!--      <div class="text-center">-->
<!--        <h4>{{ usuario.first_name }} {{ usuario.last_name }}</h4>-->
<!--      </div>-->
<!--      <b-dropdown-divider />-->
<!--      &lt;!&ndash;      <b-divider />&ndash;&gt;-->
<!--      &lt;!&ndash;div class="b-row">-->
<!--                <div>-->
<!--                    <b-avatar :src="usuario.avatar" size="70px" class="mr-4 mb-4" />-->
<!--                </div>-->

<!--                <div class="b-row">-->
<!--                    <div class="b-col md:w-3/4 sm:w-3/4 w-full">-->
<!--                      <input type="file" class="custom-file-input w-full"></input>-->
<!--                    </div>-->
<!--                    <div class="b-col md:w-1/4 sm:w-1/4 w-full">-->
<!--                      <b-button type="border" color="danger" class="w-full">Eliminar</b-button>-->
<!--                    </div>-->
<!--                    <p class="text-sm mt-2">Solo se permite imágenes en formato JPG y PNG.</p>-->
<!--                </div>-->
<!--            </div&ndash;&gt;-->
<!--    </div>-->

<!--    <div class="flex items-end mb-3">-->
<!--      <feather-icon-->
<!--        icon="UserIcon"-->
<!--        class="mr-2"-->
<!--        svg-classes="w-5 h-5"-->
<!--      />-->
<!--      <span class="leading-none font-medium">Información Personal</span>-->
<!--    </div>-->

<!--    <label class="text-sm opacity-75">Imagen de perfil</label>-->
<!--    <b-input-group class="">-->
<!--      <input-->
<!--        type="file"-->
<!--        class="custom-file-input w-full"-->
<!--        @change="gestionarArchivo"-->
<!--      >-->
<!--      <template slot="append">-->
<!--        <div class="append-text btn-addon">-->
<!--          <b-button-->
<!--            color="danger"-->
<!--            @click="preguntarEliminarImagen"-->
<!--          >-->
<!--            <b-tooltip-->
<!--              style="width: fit-content;"-->
<!--              text="Eliminar imagen"-->
<!--              position="bottom"-->
<!--            >-->
<!--              <font-awesome-icon icon="trash" />-->
<!--            </b-tooltip>-->
<!--          </b-button>-->
<!--        </div>-->
<!--      </template>-->
<!--    </b-input-group>-->

<!--    &lt;!&ndash;div class="b-row">-->
<!--            <div class="b-col md:w-3/4 sm:w-3/4 w-full">-->
<!--                <input-->
<!--                    type="file"-->
<!--                    class="custom-file-input w-full"-->
<!--                    label="Imagen de perfil"-->
<!--                >-->
<!--                </input>-->
<!--            </div>-->
<!--            <div class="b-col md:w-1/4 sm:w-1/4 w-full">-->
<!--                <b-button type="border" color="danger" class="w-full">d</b-button>-->
<!--            </div>-->
<!--        </div&ndash;&gt;-->

<!--    &lt;!&ndash; Info &ndash;&gt;-->
<!--    <input-->
<!--      v-model="usuario.first_name"-->
<!--      v-validate="'required|min:5|max:30|alpha_spaces'"-->
<!--      label="Nombres"-->
<!--      class="required w-full mt-6"-->
<!--      name="nombre"-->
<!--      placeholder="Ingrese sus nombres"-->
<!--    >-->
<!--&lt;!&ndash;    <span&ndash;&gt;-->
<!--&lt;!&ndash;      class="text-danger text-sm"&ndash;&gt;-->
<!--&lt;!&ndash;    >{{ errors.first('nombre') }}</span>&ndash;&gt;-->

<!--    &lt;!&ndash;input disabled  class="required w-full mt-6" label="Usuario" placeholder="Ingrese su usuario" v-model="usuario.username"></input&ndash;&gt;-->
<!--    <input-->
<!--      v-model="usuario.email"-->
<!--      v-validate="'required|email'"-->
<!--      disabled-->
<!--      class="required w-full mt-6"-->
<!--      label="Email"-->
<!--      name="email"-->
<!--      placeholder="Ingrese su email"-->
<!--    >-->
<!--&lt;!&ndash;    <span&ndash;&gt;-->
<!--&lt;!&ndash;      class="text-danger text-sm"&ndash;&gt;-->
<!--&lt;!&ndash;    >{{ errors.first('email') }}</span>&ndash;&gt;-->

<!--    &lt;!&ndash; Save Button &ndash;&gt;-->
<!--    <div>-->
<!--      <b-button-->
<!--        id="button-with-loading"-->
<!--        :disabled="bloqueo_boton"-->
<!--        class="ml-auto mt-5 b-con-loading__container"-->
<!--        @click="submitForm"-->
<!--      >-->
<!--        Guardar-->
<!--      </b-button>-->
<!--    </div>-->
<!--  </b-card>-->
<!--</template>-->

<!--<script>-->
<!--import axios from '@/axios'-->
<!--import Vue from 'vue'-->
<!--import rutasjson from '@/assets/utils/rutas.json'-->
<!--import {-->
<!--  BAlert, BAvatar, BButton, BCard, BDropdownDivider, BInputGroup, BTooltip,-->
<!--} from 'bootstrap-vue'-->

<!--const asyncLocalStorage = {-->
<!--  setItem(key, value) {-->
<!--    return Promise.resolve().then(() => {-->
<!--      // localStorage.setItem(key, value);-->
<!--      Vue.cookie.set(key, value, { domain: rutasjson.domain })-->
<!--    })-->
<!--  },-->
<!--}-->
<!--export default {-->
<!--  components: {-->
<!--    BInputGroup,-->
<!--    BAvatar,-->
<!--    BCard,-->
<!--    BAlert,-->
<!--    BButton,-->
<!--    BTooltip,-->
<!--    BDropdownDivider,-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--      username: 'johny_01',-->
<!--      email: 'john@admin.com',-->
<!--      company: 'SnowMash Technologies Pvt Ltd',-->
<!--      usuario: JSON.parse(this.$store.state.app.user),-->
<!--      imagen_data: '',-->
<!--      bloqueo_boton: false,-->
<!--      activeAlert: false,-->
<!--      limite_imagen_perfil: 1024, // 1MB-->
<!--    }-->
<!--  },-->
<!--  computed: {-->
<!--    activeUserInfo() {-->
<!--      return this.$store.state.AppActiveUser-->
<!--    },-->
<!--  },-->
<!--  mounted() {-->
<!--    this.usuario.first_name = `${this.usuario.first_name} ${this.usuario.last_name}`-->
<!--    this.usuario.last_name = ''-->
<!--  },-->
<!--  methods: {-->
<!--    submitForm() {-->
<!--      this.openLoadingInDiv()-->
<!--      this.$validator.validateAll().then(result => {-->
<!--        if (result) {-->
<!--          // if form have no errors-->
<!--          this.updatePerfil()-->
<!--        } else {-->
<!--          this.closeLoadingInDiv()-->
<!--        }-->
<!--      })-->
<!--    },-->
<!--    updatePerfil(e) {-->
<!--      this.openLoadingInDiv()-->
<!--      if (this.usuario.id != '') {-->
<!--        axios.post('api/usuario/editar_perfil/', {-->
<!--          token_publico: this.usuario.token_publico,-->
<!--          first_name: this.usuario.first_name,-->
<!--          // email: this.usuario.email,-->
<!--        }).then(response => {-->
<!--          if (response.data.status == 'error') {-->
<!--&lt;!&ndash;            this.$vs.dialog({&ndash;&gt; en vez de dialogo alert-->
<!--              type: 'alert',-->
<!--              color: 'danger',-->
<!--              title: 'Error!',-->
<!--              text: response.data.message,-->
<!--              acceptText: 'Aceptar',-->
<!--            })-->
<!--            this.bloqueo_boton = false-->
<!--            this.closeLoadingInDiv()-->
<!--          } else {-->
<!--            this.bloqueo_boton = false-->
<!--            this.closeLoadingInDiv()-->
<!--            this.activeAlert = true-->
<!--            this.setUserOnStorageState()-->
<!--          }-->
<!--        }).catch(error => {-->
<!--          this.bloqueo_boton = false-->
<!--          this.closeLoadingInDiv()-->
<!--        })-->
<!--      }-->
<!--    },-->

<!--    openLoadingInDiv() {-->
<!--      this.bloqueo_boton = true-->
<!--      this.$vs.loading({-->
<!--        container: '.div-with-loading',-->
<!--        scale: 0.8,-->
<!--      })-->
<!--    },-->
<!--    closeLoadingInDiv() {-->
<!--      this.$vs.loading.close('.div-with-loading > .con-b-loading')-->
<!--      this.bloqueo_boton = false-->
<!--    },-->

<!--    setUserOnStorageState() {-->
<!--      // this.currentUser.avatar_url = this.currentUser.avatar_url + '?update=' + this.currentUser.id;-->
<!--      // localStorage.setItem('usuario', JSON.stringify(this.currentUser));-->
<!--      asyncLocalStorage.setItem('usuario', JSON.stringify(this.usuario)).then(() => {-->
<!--        const usuario_saved = this.$cookie.get('usuario')-->
<!--        this.$store.commit('set_user', usuario_saved)-->
<!--      })-->
<!--    },-->

<!--    gestionarArchivo(e) {-->
<!--      const selectedImage = e.target.files[0]-->
<!--      Math.round((selectedImage.size / this.limite_imagen_perfil))-->

<!--      if (Math.round((selectedImage.size / this.limite_imagen_perfil)) > this.limite_imagen_perfil) {-->
<!--        this.$vs.dialog({-->
<!--          type: 'alert',-->
<!--          color: 'danger',-->
<!--          title: 'Error!',-->
<!--          text: 'Tamaño de imagen no permitido. El peso máximo es de 1MB.',-->
<!--          acceptText: 'Aceptar',-->
<!--        })-->
<!--        this.imagen_data = ''-->
<!--      } else if (this.checkFileExtension(selectedImage.name)) {-->
<!--        this.$vs.dialog({-->
<!--          type: 'alert',-->
<!--          color: 'danger',-->
<!--          title: 'Error!',-->
<!--          text: 'Formato de archivo no permitido. Solo se acepta JPG y PNG.',-->
<!--          acceptText: 'Aceptar',-->
<!--        })-->
<!--        this.imagen_data = ''-->
<!--      } else {-->
<!--        this.createBase64Image(selectedImage)-->
<!--      }-->
<!--    },-->
<!--    checkFileExtension(filename) {-->
<!--      filename = filename.toLowerCase()-->
<!--      const ext = filename.split('.').pop()-->
<!--      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg') {-->
<!--        return true-->
<!--      }-->
<!--      return false-->
<!--    },-->
<!--    createBase64Image(fileObject) {-->
<!--      const reader = new FileReader()-->
<!--      reader.onload = e => {-->
<!--        this.imagen_data = `${e.target.result},${fileObject.name}`-->
<!--        this.guardarImagen()-->
<!--      }-->
<!--      reader.readAsDataURL(fileObject)-->
<!--    },-->

<!--    guardarImagen() {-->
<!--      this.openLoadingInDiv()-->
<!--      axios-->
<!--        .post('api/usuario/cambiar_foto_perfil/',-->
<!--          {-->
<!--            imagen_data: this.imagen_data,-->
<!--          }).then(response => {-->
<!--          if (response.data.status == 'error') {-->
<!--            this.$vs.dialog({-->
<!--              type: 'alert',-->
<!--              color: 'danger',-->
<!--              title: 'Error!',-->
<!--              text: response.data.message,-->
<!--              acceptText: 'Aceptar',-->
<!--            })-->
<!--            this.closeLoadingInDiv()-->
<!--          } else {-->
<!--            this.$vs.dialog({-->
<!--              type: 'alert',-->
<!--              color: 'success',-->
<!--              title: 'Cambio exitoso',-->
<!--              text: response.data.message,-->
<!--              acceptText: 'Aceptar',-->
<!--            })-->
<!--            this.closeLoadingInDiv()-->
<!--            this.usuario.avatar = `${this.usuario.avatar}?update=${String(Math.floor(Math.random() * 100))}`-->
<!--            this.setUserOnStorageState()-->
<!--          }-->
<!--        })-->
<!--    },-->
<!--    preguntarEliminarImagen() {-->
<!--      this.$vs.dialog({-->
<!--        type: 'confirm',-->
<!--        color: 'danger',-->
<!--        title: 'Eliminación de imagen',-->
<!--        text: '¿Está seguro que desea eliminar la imagen?',-->
<!--        accept: this.eliminarImagen,-->
<!--        cancelText: 'Cancelar',-->
<!--        acceptText: 'Aceptar',-->
<!--      })-->
<!--    },-->
<!--    eliminarImagen() {-->
<!--      this.openLoadingInDiv()-->
<!--      axios-->
<!--        .post('api/usuario/eliminar_foto_perfil/').then(response => {-->
<!--          if (response.data.status == 'error') {-->
<!--            this.$vs.dialog({-->
<!--              type: 'alert',-->
<!--              color: 'danger',-->
<!--              title: 'Error!',-->
<!--              text: response.data.message,-->
<!--              acceptText: 'Aceptar',-->
<!--            })-->
<!--            this.closeLoadingInDiv()-->
<!--          } else {-->
<!--            this.$vs.dialog({-->
<!--              type: 'alert',-->
<!--              color: 'success',-->
<!--              title: 'Cambio exitoso',-->
<!--              text: response.data.message,-->
<!--              acceptText: 'Aceptar',-->
<!--            })-->
<!--            this.closeLoadingInDiv()-->
<!--            this.usuario.avatar = `${this.usuario.avatar}?update=${String(Math.floor(Math.random() * 100))}`-->
<!--            this.setUserOnStorageState()-->
<!--          }-->
<!--        })-->
<!--    },-->
<!--  },-->
<!--}-->
<!--</script>-->

<!--<style>-->
<!--    .required > .input&#45;&#45;label::before{-->
<!--        content: "* ";-->
<!--        color: #F56C6C;-->
<!--    }-->

<!--    .con-b-avatar{-->
<!--        background: #ffffff!important;-->
<!--    }-->

<!--    ::file-selector-button {-->
<!--        display:none!important;-->
<!--    }-->
<!--</style>-->

<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >

    <!-- general tab -->
    <b-tab active>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">General</span>
      </template>
      <AccountSettingGeneral/>

<!--      <account-setting-general-->
<!--        v-if="options.general"-->
<!--        :general-data="options.general"-->
<!--      />-->
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Cambiar contraseña</span>
      </template>
      <AccountSettingPassword />

<!--      <account-setting-password />-->
    </b-tab>
    <!--/ change password tab -->
  </b-tabs>
</template>
<script>
import { BTabs, BTab } from 'bootstrap-vue'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
  },
  data() {
    return {
      options: {},
    }
  },
}
</script>
